'use strict'

// Keep the browser presentation and durable chat-result delay in step.
var SHOUT_HOLD_MS = 3000
var SHOUT_FADE_MS = 600
var SHOUT_ROLL_DELAY_MS = 1000
var ROLL_MS = 2400
var SETTLE_MS = 800
var PARK_MS = 850
var PRESENTATION_MS = ROLL_MS + SETTLE_MS + PARK_MS
var RESULT_CHAT_DELAY_MS = SHOUT_HOLD_MS + SHOUT_FADE_MS + SHOUT_ROLL_DELAY_MS + PRESENTATION_MS + 3000

module.exports = {
  SHOUT_HOLD_MS: SHOUT_HOLD_MS,
  SHOUT_FADE_MS: SHOUT_FADE_MS,
  SHOUT_ROLL_DELAY_MS: SHOUT_ROLL_DELAY_MS,
  ROLL_MS: ROLL_MS,
  SETTLE_MS: SETTLE_MS,
  PARK_MS: PARK_MS,
  PRESENTATION_MS: PRESENTATION_MS,
  RESULT_CHAT_DELAY_MS: RESULT_CHAT_DELAY_MS
}



//////////////////
// WEBPACK FOOTER
// ../shared/lib/craps/presentation-timing.js
// module id = JvT5
// module chunks = 1